import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  
  newsList:AngularFireList<any>;
  constructor(private firebase:AngularFireDatabase) { }
  getNewsList(){
    this.newsList= this.firebase.list('news');  

  }
}
